import React from 'react';
import { ToolGateStatus } from './kofi.service';

type ToolRunAllowanceProps = {
  /** Gate state for the visitor. Nothing is rendered while the gate is off. */
  status: ToolGateStatus | null;
};

/** Shows how many free or supporter runs the visitor has left, when the gate is on. */
const ToolRunAllowance: React.FC<ToolRunAllowanceProps> = ({ status }) => {
  if (!status?.enabled) {
    return null;
  }
  const label =
    status.grantRemaining > 0
      ? `${status.grantRemaining} supporter ${status.grantRemaining === 1 ? 'check' : 'checks'} left`
      : `${status.freeRemaining} free ${status.freeRemaining === 1 ? 'check' : 'checks'} left`;
  return (
    <p className="jo-body-subtle mb-2 text-sm" role="status">
      {label}
    </p>
  );
};

export default ToolRunAllowance;
